import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { Text } from '@chakra-ui/react';

const SessionDuration = ({ durationSeconds, ...textProps }) => {
  if (!durationSeconds || !Number.isInteger(Number(durationSeconds))) {
    return '-';
  }

  const durationMinutes = durationSeconds / 60;
  const fullHours = Math.floor(durationMinutes / 60);
  const leftOverMinutes = durationMinutes % 60;

  let component;
  if (fullHours > 0) {
    if (leftOverMinutes > 0) {
      component = (
        <Trans i18nKey="common.duration" values={{ hours: fullHours, minutes: leftOverMinutes }} />
      );
    } else {
      component = <Trans i18nKey="common.durationHoursOnly" values={{ hours: fullHours }} />;
    }
  } else {
    component = (
      <Trans i18nKey="common.durationMinutesOnly" values={{ minutes: leftOverMinutes }} />
    );
  }
  return <Text {...textProps}>{component}</Text>;
};

SessionDuration.propTypes = {
  durationSeconds: PropTypes.number,
};

export default SessionDuration;
